import { Heading,VStack } from "@bpba/ui-components";

type ResultProps = {
  message?: string;
};

export const ResultExito = (props: ResultProps) => {
  if (!props.message) return <></>;

  return (
    <VStack>
      <Heading level={2} fontWeight={400} children={props.message} color="primary.0" tabIndex={0} />
    </VStack>
  );
};
